import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1 className='text-center text-3xl font-bold mt-5'>কিয়া টোয়ান ?</h1>
            <img src="images/NotFound.gif" alt="" className='mx-auto' />
        </div>
    );
};

export default NotFound;